import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';


enum SiteLanguageCode {
	es = 'es',
	us = 'us',
	en = 'en',
	br = 'br'
};

const defaultSiteLanguage: string = SiteLanguageCode.br;


@Injectable({
	providedIn: 'root'
})
export class LanguageService {

	language: string;

	constructor(private router: Router, private translateService: TranslateService) { }

	defineLanguage(languageParam: string): string {
		let lang: string = this.getValidSiteLanguageCode(languageParam);
		localStorage.setItem('lang', lang);
		return lang;
	}

	private getValidSiteLanguageCode(languageCode: string): string {
		switch (languageCode) {
			case SiteLanguageCode.es:
				return SiteLanguageCode.es;
			case SiteLanguageCode.us:
				return SiteLanguageCode.us;
			case SiteLanguageCode.en:
				return SiteLanguageCode.us;
			case SiteLanguageCode.br:
				return SiteLanguageCode.br;
			default:
				return SiteLanguageCode.br;
		}
	}

	get siteLanguage(): string {

		let lang = localStorage.getItem('lang');
		if (lang)
			return localStorage.getItem('lang');
		return defaultSiteLanguage;
	}

	changeSiteLanguage(language: string): void {

		let lang: string = language.toLowerCase();
		localStorage.setItem('lang', lang);
		this.translateService.use(lang);
	}

	resetLanguage(): void {

		localStorage.setItem('lang', SiteLanguageCode.br);
	}

	translate(key: string): string {
		return this.translateService.instant(key + '.TRANSLATION');
	}

	getSiteLanguageCodes(): Array<string> {
		return [SiteLanguageCode.es, SiteLanguageCode.us, SiteLanguageCode.br];
	}

}
